import URLManager from '../config/URLManager';
import { FEATURE_FLAGS_FAILED_MSG } from '../constants/TelemetryConstants';
import {
    Origin,
    Scope,
    Service,
} from '../enums/ClientErrorStrings';
import { http } from '../http';
import { getDisplayErrorCode } from '../utils/CommonUtils';
import logger from '../utils/Logging';
import FeatureFlagManager from './FeatureFlagManager';

interface FlagDTO {
    key: string;
    value: string;
}

interface FlagsCache {
    [key: string]: string;
}

const FALSY_VALUES = [ undefined, 'False' ];

export default class ProteusFeatureFlagManager extends FeatureFlagManager {
    private _isReady: Promise<void>;
    private _flags: FlagsCache = {};

    private constructor(organizationId: string, tenantId: string, userKey = '', userEmail = '') {
        super();
        const context = {
            key: userKey,
            email: userEmail,
            name: userKey,
            organizationId,
            tenantId,
        };
        this._isReady = this.fetchflags(context);
    }

    static initialize(organizationId: string, tenantId: string, userKey = '', userEmail = ''): FeatureFlagManager | null {
        if (!ProteusFeatureFlagManager.instance) {
            FeatureFlagManager.instance = new ProteusFeatureFlagManager(organizationId, tenantId, userKey, userEmail);
        }
        return ProteusFeatureFlagManager.instance;
    }

    async waitUntilReady(): Promise<void> {
        return this._isReady;
    }

    isEnabled(flagKey: string): boolean {
        const flagValue = this._flags[flagKey];
        if (FALSY_VALUES.includes(flagValue)) {
            return false;
        }
        return true;
    }

    private async fetchflags(context: Record<string, string>) {
        const serializedContext = btoa(JSON.stringify(context));
        try {
            const { data } = await http.get<FlagDTO[]>(
                URLManager.url().featureManagement?.proteusServiceUrl + `?context=${serializedContext}`,
            );
            data.forEach(({
                key, value,
            }) => (this._flags[key] = value));
        } catch (error) {
            const backendCode = getDisplayErrorCode(Scope.Core, Service.HELPER, Origin.BOOTSTRAPROVIDER, error, error.response?.status);
            logger.error({
                identifier: Scope.Core,
                message: FEATURE_FLAGS_FAILED_MSG,
                error,
                backendCode,
            });
        }
    }
}
